export enum ComunicationStatus {
    Sent = 7,
    Read = 8,
    Scheduled = 9,
    Unread = 10
}
export enum ContactSource {
    Internal = 0,
    External = 1
}
export enum ContactType {
    Phone = 0,
    Email = 1
}
export enum ServiceDateType {
    Checkin = 0,
    Cancellation = 1
}
export enum StakeholderType {
    Customer = 0,
    Provider = 1
}